export const DEFAULT_UPGRADE_REPEAT_INITIAL_INTERVAL_MS = 1000;
export const HOV_GAIN_FAMILY_UPGRADE_UNLOCKED_REPEAT_INITIAL_INTERVAL_MS = 500;
export const HOV_GAIN_FAMILY_UPGRADE_MARATHON_REPEATER_INITIAL_INTERVAL_MS = 250;
export const HOV_AMPLIFIER_UPGRADE_REPEAT_INITIAL_INTERVAL_MS = 1000;
export const HOV_AMPLIFIER_UPGRADE_UNLOCKED_REPEAT_INITIAL_INTERVAL_MS = 250;
export const HOV_AMPLIFIER_UPGRADE_REPEAT_MIN_INTERVAL_MS = 80;
export const HOV_AMPLIFIER_UPGRADE_REPEAT_DECAY = 0.85;
export const UPGRADE_HOVER_REPEATER_MIN_INTERVAL_MS = 80;

export type UpgradeRepeatInitialIntervalSource = number | (() => number);

/**
 * Game-speed multiplier for upgrade hover repeat timing. Provided as a fixed
 * value or a getter so admin/dev runtime speed changes are read per repeat tick.
 * Treated as `1` when unspecified.
 */
export type UpgradeRepeatSpeedMultiplierSource = number | (() => number);
